export const environment = {
  production: true,
  appName: 'prequalification',
  envName: 'acceptance',
  redirectUrl: 'https://owner.acceptance.ygreneworks.com',
  gmapsApiKey: 'AIzaSyCYMTLmXRw3cSB0_3MCfA0FQwXIHJGNT3U',
  secureUploaderServiceUrl: 'https://upload.api.acceptance.ygreneworks.com',
  legacyApi: {
    base: 'https://ops.acceptance.ygreneworks.com/api',
    host: 'https://ops.acceptance.ygreneworks.com',
  },
  launchDarklyClientId: '5b7b2c6d9a879f2aa36d701d',
  featureFlagConfig: {
    'yt-13358-prequal-calculator': true,
    'yn-167-unsecured-mvp-po': true,
    'yt-18411-unsecured-product-phase-2-po': true,
    'yt-19374-pace-pause-prequal-updates': true,
    'yt-19193-block-duplicate-po-email': true,
    'yt-20172-allow-shared-email': true,
  },
  showSnackBar: false,
  sentryDsn: 'https://cb011301fd5e4d05aa210ea5b67ad413@sentry.io/1207347',
  managerClientConfig: { baseUrl: 'https://ops.acceptance.ygreneworks.com' },
  datadog: {
    clientToken: 'pub093865466e5d702b50162c1c3a059fd3',
    applicationId: '5583d963-8b03-41f1-bf68-92a1a8a1dda6',
  },
  verix: {
    clientId: '605a4a587ea0ee7ceed317f4d634ba22',
    environment: 'development',
  },
  googleAnalyticsTrackingId: 'UA-99769428-14',
  ambassadorReferralGetCookieUrl: 'https://mbsy.co/embed/v2/getcookie/ygrene',
  hotjarSiteId: '1905417',
  yodlee: {
    fastlinkUrl:
      'https://usyinode.stage.yodleeinteractive.com/authenticate/private-usyistage23/?channelAppName=usyichnnel',
  },
};
